module.exports = __webpack_public_path__ + "img/beetle_leg5.1ec93364.png";